import DomainsRequest from '@/@api/domains'
import { ref, computed } from '@vue/composition-api'
// import store from '@/store'
// import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { debouncedWatch } from '@vueuse/core'

const domains = ref([])

export default function useDomains() {
  // Use toast
  const toast = useToast()

  const refDomainListTable = ref(null)

  // const domains = ref([])

  // Table Handlers
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    {
      label: 'Título',
      key: 'name',
      sortable: true,
      thStyle: { width: '50%' },
    },
    {
      label: 'Dominio',
      key: 'domain',
      sortable: true,
      thStyle: { width: '50%' },
    },
    { label: 'Activo', key: 'status', sortable: true },
    { label: 'Acciones', key: 'actions' },
  ]
  const perPage = ref(10)
  const totalDomains = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refDomainListTable.value ? refDomainListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDomains.value,
    }
  })

  const refetchData = () => {
    refDomainListTable.value.refresh()
  }

  debouncedWatch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  }, { debounce: 400 })

  const fetchDomains = (ctx, callback) => {
    DomainsRequest.list({
      params: {
        q: searchQuery.value,
        paginate: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      },
    })
      .then(response => {
        const { data, total } = response.data.data

        callback(data.map(domain => ({ ...domain, loading: false })))
        totalDomains.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching domains list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  async function fetchDomainsSelector(isMemo = false) {
    if (isMemo && domains.value.length) {
      return Promise.resolve(domains.value)
    }

    try {
      const { data } = await DomainsRequest.select()

      const list = data.data.map(domain => ({
        id: domain.id,
        value: domain.id,
        label: domain.name,
        domain: domain.domain,
      }))

      domains.value = list

      return list
    } catch (error) {
      throw new Error(error)
    }
  }

  async function domainStore(body) {
    try {
      const { data } = await DomainsRequest.store(body)

      toast({
        component: ToastificationContent,
        props: {
          title: data.message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  async function domainUpdate(id, body) {
    try {
      const { data } = await DomainsRequest.update(id, body)

      toast({
        component: ToastificationContent,
        props: {
          title: data.message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  async function domainDelete(id) {
    try {
      const { data } = await DomainsRequest.destroy(id)

      toast({
        component: ToastificationContent,
        props: {
          title: data.message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  fetchDomainsSelector(true).then(list => {
    domains.value = list
  })

  const resolveIsoDomain = iso => {
    if (!iso) return ''

    const dic = domains.value.reduce((acc, domain) => {
      acc[domain.value] = domain.label

      return acc
    }, {})

    return dic[iso] ?? iso
  }

  return {
    domains,
    fetchDomains,
    fetchDomainsSelector,
    tableColumns,
    perPage,
    currentPage,
    totalDomains,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDomainListTable,

    resolveIsoDomain,

    refetchData,
    domainStore,
    domainUpdate,
    domainDelete,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
